"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopPage = void 0;
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var categories_1 = require("../../../api/calls/product/categories");
var products_1 = require("../../../api/calls/product/products");
var recently_viewed_1 = require("../../../api/calls/product/recently_viewed");
var getRootPath_1 = require("../../../helpers/getRootPath");
// import { IBasketSliceState } from "../../../reducers/slices/basket";
var selection_1 = require("../../../reducers/slices/selection");
var category_products_1 = require("./category_products");
var Boosst_png_1 = __importDefault(require("../../../assets/partners/Boosst.png"));
var BEBY_CO_png_1 = __importDefault(require("../../../assets/partners/BEBY.CO.png"));
var GlowUP_png_1 = __importDefault(require("../../../assets/partners/GlowUP.png"));
var Quena_io_png_1 = __importDefault(require("../../../assets/partners/Quena.io.png"));
var majine_png_1 = __importDefault(require("../../../assets/partners/majine.png"));
var calculateDiscountPercentage_1 = require("../../../helpers/calculateDiscountPercentage");
var ShopPage = function () {
    var location = (0, react_router_dom_1.useLocation)();
    var rootPath = (0, getRootPath_1.getRootPath)(location);
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    // const { products } = useSelector<any, IBasketSliceState>((state) => state.basketState);
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _a = (0, react_1.useState)([]), categories = _a[0], setCategories = _a[1];
    var _b = (0, react_1.useState)([]), recentlyViewed = _b[0], setRecentlyViewed = _b[1];
    var _c = (0, react_1.useState)([]), random1Category = _c[0], setRandom1Category = _c[1];
    var _d = (0, react_1.useState)([]), random2Category = _d[0], setRandom2Category = _d[1];
    var _e = (0, react_1.useState)([]), random3Category = _e[0], setRandom3Category = _e[1];
    var _f = (0, react_1.useState)([]), random1Products = _f[0], setRandom1Products = _f[1];
    var _g = (0, react_1.useState)(1), random1TotalRecords = _g[0], setRandom1TotalRecords = _g[1];
    var _h = (0, react_1.useState)(10), random1RecordsPerPage = _h[0], setRandom1RecordsPerPage = _h[1]; //Change this
    var _j = (0, react_1.useState)(1), random1CurrentPage = _j[0], setRandom1CurrentPage = _j[1];
    var _k = (0, react_1.useState)([]), random2Products = _k[0], setRandom2Products = _k[1];
    var _l = (0, react_1.useState)(1), random2TotalRecords = _l[0], setRandom2TotalRecords = _l[1];
    var _m = (0, react_1.useState)(10), random2RecordsPerPage = _m[0], setRandom2RecordsPerPage = _m[1]; //Change this
    var _o = (0, react_1.useState)(1), random2CurrentPage = _o[0], setRandom2CurrentPage = _o[1];
    var _p = (0, react_1.useState)([]), random3Products = _p[0], setRandom3Products = _p[1];
    var _q = (0, react_1.useState)(1), random3TotalRecords = _q[0], setRandom3TotalRecords = _q[1];
    var _r = (0, react_1.useState)(10), random3RecordsPerPage = _r[0], setRandom3RecordsPerPage = _r[1]; //Change this
    var _s = (0, react_1.useState)(1), random3CurrentPage = _s[0], setRandom3CurrentPage = _s[1];
    var basket = (0, react_redux_1.useSelector)(function (state) { return state.basketState; }).basket;
    var _t = (0, react_1.useState)({
        _id: "",
        sku: "",
        title: "",
        sub_title: "",
        description: "",
        price: "0",
        promotion_price: "0",
        on_promotion: false,
        image_url: "",
        image_list: [],
        rating: {
            average: "0",
            count: "0",
        },
    }), retrievedProduct = _t[0], setRetrievedProduct = _t[1];
    var _u = (0, react_1.useState)(false), isAddingToCart = _u[0], setIsAddingToCart = _u[1];
    var _v = (0, react_1.useState)(), productIndex = _v[0], setProductIndex = _v[1];
    (0, react_1.useEffect)(function () {
        (0, categories_1.getCategories)({
            page: "1",
        }).then(function (response) {
            setCategories(response.content.product_category_list);
        });
    }, []);
    (0, react_1.useEffect)(function () {
        var _a;
        if (user.user._id) {
            (0, recently_viewed_1.getRecentlyViewedProducts)({
                user_id: (_a = user.user._id) !== null && _a !== void 0 ? _a : "",
            }).then(function (response) {
                var _a;
                // // console.log("Recent products fetched", response);
                setRecentlyViewed((_a = response.content) !== null && _a !== void 0 ? _a : []);
            });
        }
    }, [user]);
    (0, react_1.useEffect)(function () {
        if (categories && categories.length > 0) {
            var rc1 = categories[Math.floor(Math.random() * categories.length)];
            // // console.log("rc1", rc1);
            setRandom1Category(rc1);
            var rc2 = categories[Math.floor(Math.random() * categories.length)];
            do {
                rc2 = categories[Math.floor(Math.random() * categories.length)];
            } while (rc1.name === rc2.name);
            // console.log("rc2", rc2);
            setRandom2Category(rc2);
            var rc3 = categories[Math.floor(Math.random() * categories.length)];
            do {
                rc3 = categories[Math.floor(Math.random() * categories.length)];
            } while (rc1.name === rc2.name || rc1.name === rc3.name || rc2.name === rc3.name);
            // console.log("rc3", rc3);
            setRandom3Category(rc3);
        }
    }, [categories]);
    (0, react_1.useEffect)(function () {
        if (random1Category === null || random1Category === void 0 ? void 0 : random1Category._id) {
            getRandom1Products(random1Category._id);
        }
    }, [random1Category]);
    (0, react_1.useEffect)(function () {
        if (random1Category === null || random1Category === void 0 ? void 0 : random1Category._id) {
            getRandom1Products(random1Category._id);
        }
    }, [random1CurrentPage]);
    (0, react_1.useEffect)(function () {
        if (random2Category === null || random2Category === void 0 ? void 0 : random2Category._id) {
            getRandom2Products(random2Category._id);
        }
    }, [random2Category]);
    (0, react_1.useEffect)(function () {
        if (random2Category === null || random2Category === void 0 ? void 0 : random2Category._id) {
            getRandom2Products(random2Category._id);
        }
    }, [random2CurrentPage]);
    (0, react_1.useEffect)(function () {
        if (random3Category === null || random3Category === void 0 ? void 0 : random3Category._id) {
            getRandom3Products(random3Category._id);
        }
    }, [random3Category]);
    (0, react_1.useEffect)(function () {
        if (random3Category === null || random3Category === void 0 ? void 0 : random3Category._id) {
            getRandom3Products(random3Category._id);
        }
    }, [random3CurrentPage]);
    var getRandom1Products = function (categporyId) {
        (0, products_1.getProducts)({
            category_id: categporyId,
            page: random1CurrentPage.toString(),
            size: random1RecordsPerPage.toString(),
        }).then(function (response) {
            // console.log("response.content", response.content);
            var list = response.content.product_list;
            setRandom1TotalRecords(parseInt(response.content.count));
            setRandom1Products(list.map(function (product) {
                return {
                    _id: product._id,
                    title: product.title,
                    image: product.image_url,
                    amount: product.price,
                    // rating: product.rating.average,
                    borderColor: "border-borders-light",
                    shadowColor: "shadow-shadows-dark/5",
                    textColor: "text-primary",
                    titleColor: "text-secondary",
                    amountColor: product.on_promotion ? "text-disabled" : "text-primary",
                    starActiveColor: "text-borders-light",
                    starInactiveColor: "text-borders-light",
                    loaderColor: "text-primary",
                    backgroundColor: "bg-white",
                    discountLabel: (0, calculateDiscountPercentage_1.generateDiscountLabel)(product.on_promotion, product.price, product.promotion_price),
                    discountAmount: product.on_promotion ? product.promotion_price : "",
                };
            }));
        });
    };
    var getRandom2Products = function (categporyId) {
        (0, products_1.getProducts)({
            category_id: categporyId,
            page: random2CurrentPage.toString(),
            size: random2RecordsPerPage.toString(),
        }).then(function (response) {
            // console.log("response.content", response.content);
            var list = response.content.product_list;
            setRandom2TotalRecords(parseInt(response.content.count));
            setRandom2Products(list.map(function (product) {
                return {
                    _id: product._id,
                    title: product.title,
                    image: product.image_url,
                    amount: product.price,
                    // rating: product.rating.average,
                    borderColor: "border-borders-light",
                    shadowColor: "shadow-shadows-dark/5",
                    textColor: "text-primary",
                    amountColor: product.on_promotion ? "text-disabled" : "text-primary",
                    starActiveColor: "text-borders-light",
                    starInactiveColor: "text-borders-light",
                    loaderColor: "text-primary",
                    backgroundColor: "bg-white",
                    discountLabel: (0, calculateDiscountPercentage_1.generateDiscountLabel)(product.on_promotion, product.price, product.promotion_price),
                    discountAmount: product.on_promotion ? product.promotion_price : "",
                };
            }));
        });
    };
    var getRandom3Products = function (categporyId) {
        (0, products_1.getProducts)({
            category_id: categporyId,
            page: random3CurrentPage.toString(),
            size: random3RecordsPerPage.toString(),
        }).then(function (response) {
            // console.log("response.content3", response.content);
            var list = response.content.product_list;
            setRandom3TotalRecords(parseInt(response.content.count));
            setRandom3Products(list.map(function (product) {
                return {
                    _id: product._id,
                    title: product.title,
                    image: product.image_url,
                    amount: product.price,
                    // rating: product.rating.average,
                    borderColor: "border-borders-light",
                    shadowColor: "shadow-shadows-dark/5",
                    textColor: "text-primary",
                    titleColor: "text-secondary",
                    amountColor: product.on_promotion ? "text-disabled" : "text-primary",
                    starActiveColor: "text-borders-light",
                    starInactiveColor: "text-borders-light",
                    loaderColor: "text-primary",
                    backgroundColor: "bg-white",
                    discountLabel: (0, calculateDiscountPercentage_1.generateDiscountLabel)(product.on_promotion, product.price, product.promotion_price),
                    discountAmount: product.on_promotion ? product.promotion_price : "",
                };
            }));
        });
    };
    var FeaturedBrands = function () {
        var listOfImages = [Boosst_png_1.default, BEBY_CO_png_1.default, GlowUP_png_1.default, Quena_io_png_1.default, majine_png_1.default];
        return (react_1.default.createElement("div", { className: "flex w-full justify-between" }, listOfImages.map(function (image) {
            return react_1.default.createElement("img", { src: image, className: "h-[15px] object-contain" });
        })));
    };
    return (react_1.default.createElement("div", { className: "flex flex-col items-center" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-8" },
            react_1.default.createElement("div", { className: "flex flex-col lg:flex-row gap-4" },
                react_1.default.createElement("div", { className: "flex-none flex lg:flex-col gap-8 lg:max-w-[16rem]" },
                    react_1.default.createElement(doshx_controls_web_1.SideNavigationControl, { title: "Shop all categories", items: categories.map(function (category, index) { return ({
                            index: index,
                            _id: category._id,
                            title: category.name,
                            items: category.sub_categories.map(function (sub_category, index) { return ({
                                _id: sub_category._id,
                                title: sub_category.name,
                                items: [],
                            }); }),
                        }); }), onItemClick: function (item, level) {
                            // console.log(`item clicked level: ${level} item:`, item);
                            dispatch((0, selection_1.setSelectedCategory)({ item: item, level: level }));
                            navigate("".concat(rootPath, "/category/").concat(level, "/").concat(item._id, "/").concat(encodeURI(item.title)));
                        } }),
                    react_1.default.createElement("div", { className: "hidden lg:block flex-none" },
                        react_1.default.createElement(doshx_controls_web_1.CommitmentsControl, { commitments: [
                                // { icon: faTruck, title: "Free Delivery", description: "From R40" },
                                { icon: pro_solid_svg_icons_1.faStar, title: "Best Quality", description: "Brand" },
                                // { icon: faHistory, title: "1 Year", description: "For Free Return" },
                                // { icon: faEnvelope, title: "Feedback", description: "99% Real Data" },
                                { icon: pro_solid_svg_icons_1.faCreditCard, title: "Payment", description: "Secure" },
                            ] }))),
                react_1.default.createElement("div", { className: "flex-1" },
                    react_1.default.createElement(react_router_dom_1.Routes, null,
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/*", element: react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                                react_1.default.createElement(doshx_controls_web_1.ProductsBigControl, { colors: {
                                        discount: {
                                            textColor: "text-shadows-light",
                                            // iconColor: `text-primary`,
                                            amountColor: "text-primary",
                                            backgroundColor: "bg-primary",
                                        },
                                    }, category: { name: random1Category.name, color: "text-secondary" }, products: random1Products, onClick: function (product) {
                                        // console.log("product", product);
                                        dispatch((0, selection_1.setSelectedProduct)(product));
                                        navigate("/product/".concat(product._id));
                                    }, pagination: {
                                        currentPage: random1CurrentPage,
                                        totalRecords: random1TotalRecords,
                                        recordsPerPage: random1RecordsPerPage,
                                        colors: {
                                            selected: {
                                                backgroundColor: "bg-secondary",
                                                textColor: "text-white",
                                                borderColor: "border-borders-light",
                                            },
                                            unselected: {
                                                backgroundColor: "bg-secondary",
                                                textColor: "text-white",
                                                borderColor: "border-borders-light",
                                            },
                                        },
                                        onClick: function (pageNumber) {
                                            setRandom1CurrentPage(pageNumber);
                                        },
                                    } }),
                                react_1.default.createElement(doshx_controls_web_1.ProductsBigControl, { colors: {
                                        discount: {
                                            textColor: "text-shadows-light",
                                            // iconColor: `text-primary`,
                                            amountColor: "text-primary",
                                            backgroundColor: "bg-primary",
                                        },
                                    }, category: {
                                        name: random3Category.name,
                                        color: "text-secondary",
                                    }, products: random3Products, onClick: function (product) {
                                        // console.log("product", product);
                                        dispatch((0, selection_1.setSelectedProduct)(product));
                                        navigate("/product/".concat(product._id));
                                    }, pagination: {
                                        currentPage: random3CurrentPage,
                                        totalRecords: random3TotalRecords,
                                        recordsPerPage: random3RecordsPerPage,
                                        onClick: function (pageNumber) {
                                            setRandom3CurrentPage(pageNumber);
                                        },
                                        colors: {
                                            selected: {
                                                backgroundColor: "bg-secondary",
                                                textColor: "text-white",
                                                borderColor: "border-borders-light",
                                            },
                                            unselected: {
                                                backgroundColor: "bg-secondary",
                                                textColor: "text-white",
                                                borderColor: "border-borders-light",
                                            },
                                        },
                                    } }),
                                react_1.default.createElement(doshx_controls_web_1.ProductsBigControl, { colors: {
                                        discount: {
                                            textColor: "text-shadows-light",
                                            // iconColor: `text-primary`,
                                            amountColor: "text-primary",
                                            backgroundColor: "bg-primary",
                                        },
                                    }, category: {
                                        name: random2Category.name,
                                        color: "text-secondary",
                                    }, products: random2Products, 
                                    // button={{ borderColor: "border-primary", textColor: "text-primary", onClick: () => {} }}
                                    onClick: function (product) {
                                        // console.log("product", product);
                                        dispatch((0, selection_1.setSelectedProduct)(product));
                                        navigate("/product/".concat(product._id));
                                    }, pagination: {
                                        currentPage: random2CurrentPage,
                                        totalRecords: random2TotalRecords,
                                        recordsPerPage: random2RecordsPerPage,
                                        onClick: function (pageNumber) {
                                            setRandom2CurrentPage(pageNumber);
                                        },
                                        colors: {
                                            selected: {
                                                backgroundColor: "bg-secondary",
                                                textColor: "text-white",
                                                borderColor: "border-borders-light",
                                            },
                                            unselected: {
                                                backgroundColor: "bg-secondary",
                                                textColor: "text-white",
                                                borderColor: "border-borders-light",
                                            },
                                        },
                                    } })) }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/category/:level/:categoryId/:categoryName", element: react_1.default.createElement(category_products_1.CategoryProductsPage, null) })))),
            recentlyViewed && recentlyViewed.length > 0 && (react_1.default.createElement(doshx_controls_web_1.ProductCarouselSmallControl, { colors: {
                    discount: {
                        textColor: "text-shadows-light",
                        // iconColor: `text-primary`,
                        amountColor: "text-primary",
                        backgroundColor: "bg-primary",
                    },
                }, category: {
                    name: "Recently viewed",
                    color: "text-secondary",
                }, products: recentlyViewed.map(function (product, index) {
                    return {
                        _id: product._id,
                        image: product.image_url,
                        title: product.title,
                        amount: product.price,
                        // rating: product.rating.average,
                        borderColor: "border-borders-light",
                        shadowColor: "shadow-shadows-light",
                        textColor: "text-primary",
                        amountColor: product.on_promotion ? "text-disabled" : "text-primary",
                        starActiveColor: "text-borders-light",
                        starInactiveColor: "text-borders-light",
                        loaderColor: "text-primary",
                        discountLabel: (0, calculateDiscountPercentage_1.generateDiscountLabel)(product.on_promotion, product.price, product.promotion_price),
                        discountAmount: product.on_promotion ? product.promotion_price : "",
                        colors: {
                            discount: {
                                // textColor: `text-success`,
                                // iconColor: `text-primary`,
                                amountColor: "text-primary",
                                // backgroundColor: `bg-red-500`,
                            },
                        },
                    };
                }), onClick: function (product) {
                    // console.log("product", product);
                    dispatch((0, selection_1.setSelectedProduct)(product));
                    navigate("/product/".concat(product._id));
                } })))));
};
exports.ShopPage = ShopPage;
